export default{
    tel1 : "",
    tel2 : "",
    mail : ""
}